import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notification } from 'antd';

import api from '../../../utils/api';
import { GET_SCHOLARSHIP_PERCENTAGE_CONFIG_QUERY_KEY } from './useGetScholarshipPercentageConfigQuery';

export interface ScholarshipPercentagePayload {
  minPercent: number;
  maxPercent: number;
  stepInterval: number;
  allowedValues: string;
}

interface ConfigureResponse {
  statusCode?: number;
  message: string;
  data?: unknown;
}

export const useConfigureScholarshipPercentageMutation = () => {
  const queryClient = useQueryClient();

  const configure = async (payload: ScholarshipPercentagePayload): Promise<ConfigureResponse> => {
    return (await api.post('/admin/scholarship/percentage-config', payload))?.data;
  };

  const mutation = useMutation({
    mutationKey: ['configure-scholarship-percentage'],
    mutationFn: configure,
  });

  const configureHandler = async (values: ScholarshipPercentagePayload, resetForm?: () => void) => {
    try {
      const data = await mutation.mutateAsync(values);
      notification.success({
        message: data?.message || 'Percentage configuration saved successfully',
      });
      queryClient.refetchQueries({ queryKey: GET_SCHOLARSHIP_PERCENTAGE_CONFIG_QUERY_KEY });
      resetForm?.();
    } catch (error: any) {
      notification.error({
        message: 'Error',
        description:
          error?.response?.data?.message ||
          error?.response?.data?.title ||
          'Failed to save percentage configuration',
      });
    }
  };

  return {
    configureHandler,
    isLoading: mutation.isPending,
  };
};
